// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"694":"f4ce661f","776":"7192c0fe","816":"7bb16405"}[chunkId] + ".chunk.js";
};